'use strict';

const {
  displayStoreGroupPenalty,
  displayMinMaxPenalty,
  displayMaxUpDown,
} = require('../enums/feature-flags');

const truncationLength = {
  scopeText: 110,
  selectedStoreGroupsText: 80,
};

const ruleHeaders = [
  {
    field: 'economicPenalty',
    class: 'economic-penalty-traffic-light',
    headline: 'settings.penaltyRules.economicPenaltyInitial',
  },
  {
    field: 'competitorPenalty',
    class: 'competitor-penalty-traffic-light',
    headline: 'settings.penaltyRules.competitorPenaltyInitial',
  },
  {
    field: 'architecturePenalty',
    class: 'architecture-penalty-traffic-light',
    headline: 'settings.penaltyRules.architecturePenaltyInitial',
  },
  {
    field: 'minMaxPenalty',
    class: 'minmax-penalty-traffic-light',
    headline: 'settings.penaltyRules.minMaxPenaltyInitial',
    featureFlag: displayMinMaxPenalty,
  },
  {
    field: 'maxUpDown',
    class: 'maxupdown-traffic-light',
    headline: 'settings.penaltyRules.maxUpDownInitial',
    featureFlag: displayMaxUpDown,
  },
  {
    field: 'storeGroupPenalty',
    class: 'store-group-penalty-traffic-light',
    headline: 'settings.penaltyRules.storeGroupPenaltyInitial',
    featureFlag: displayStoreGroupPenalty,
  },
  {
    field: 'pricePointing',
    class: 'price-pointing-traffic-light',
    headline: 'settings.penaltyRules.pricePointingInitial',
  },
];

module.exports = {
  ruleHeaders,
  truncationLength,
};
